// 消息类型枚举
export const MESSAGE_TYPE = {
  // 系统消息
  SYSTEM: 1,
  // 任务消息
  TASK: 2,
  // 验收消息
  ACCEPT: 3,
  // 结算消息
  SETTLE: 4,
};

export const MESSAGE_TYPE_TEXT = {
  // 系统消息
  [MESSAGE_TYPE.SYSTEM]: "系统消息",
  // 任务消息
  [MESSAGE_TYPE.TASK]: "任务消息",
  // 验收消息
  [MESSAGE_TYPE.ACCEPT]: "验收消息",
  // 结算消息
  [MESSAGE_TYPE.SETTLE]: "结算消息",
};
